<template>
  <section class="hero-splash" :class="`hero-splash--${theme}`">
    <div class="hero-splash__container">
      <div class="hero-splash__content">
        <h1 class="hero-splash__title" v-html="formattedTitle"></h1>
        <p class="hero-splash__description">{{ subtitle }}</p>
      </div>
      <div class="hero-splash__image">
        <img :src="getImagePath" :alt="title" />
      </div>
    </div>
  </section>
</template>

<script>
import defaultImage from '@/assets/images/turnKeyOnDevices.png';

export default {
  name: 'HeroSplash',
  props: {
    title: {
      type: String,
      default: 'turnKey Solutions for Research Excellence'
    },
    subtitle: {
      type: String,
      default: 'Empowering research organisations with innovative tools and solutions to drive discovery and innovation.'
    },
    image: {
      type: String,
      default: defaultImage
    },
    theme: {
      type: String,
      default: 'dark',
      validator: (value) => ['dark', 'light'].includes(value)
    }
  },
  computed: {
    getImagePath() {
      // If the image prop is a string path, try to require it
      if (typeof this.image === 'string' && this.image.startsWith('@/')) {
        try {
          return require(this.image);
        } catch (e) {
          console.warn('Failed to load image:', this.image);
          return defaultImage;
        }
      }
      // If it's already an imported image or the default, use it directly
      return this.image;
    },
    formattedTitle() {
      // Replace text wrapped in ** with styled spans
      return this.title.replace(
        /\*\*(.*?)\*\*/g, 
        (_, text) => `<span class="highlight">${text}</span>`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-splash {
  width: 100%;
  padding: $spacing-xl 0;

  &--dark {
    background-color: $color-secondary;
    color: $color-white;
  }

  &--light {
    background-color: $color-white;
    color: $color-text;
  }

  &__container {
    max-width: $container-width;
    margin: 0 auto;
    padding: 0 $spacing-lg;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: $spacing-xl;
    align-items: center;

    @include media-down(md) {
      grid-template-columns: 1fr;
      gap: $spacing-lg;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: $spacing-md;
  }

  &__title {
    //font-size: $font-size-h1;
    //font-weight: $font-weight-bold;
    //line-height: $line-height-heading;
    margin: 0;

    :deep(.highlight) {
      color: $orange;
      font-weight: normal;
      @include museo-700;
    }
  }

  &__description {
    //font-size: $font-size-lg;
    //line-height: $line-height-base;
    margin: 0;
    opacity: 0.9;
  }

  &__image {
    img {
      width: 100%;
      height: auto;
      border-radius: $border-radius;
    }
  }
}
</style> 